/**
 * Practice mode strip (renders `ui.practice`): side being drilled, plays run, last result, and the two practice
 * commands (RESET BALL = R / pad Back, SWAP SIDES = Tab).
 *
 * The strip sits between the two power medallions, so it must never grow: the last result ("LAST: +7 YDS") pops in
 * IN PLACE of "PLAY n" for a few seconds instead of widening the strip over P1's special medallion.
 */
import { useEffect, useState } from 'preact/hooks';
import { useActions } from '../actions';
import { Key } from '../components';
import { ui } from '@hf/client-core/ui-model/store';

/** How long the last result replaces the play counter. */
export const LAST_RESULT_MS = 2800;

export function PracticePanel() {
  const p = ui.practice.value;
  const actions = useActions();
  const key = p?.lastResult ? `${p.plays}-${p.lastResult}` : '';
  const [shown, setShown] = useState('');
  useEffect(() => {
    if (!key) return;
    setShown(key);
    const t = setTimeout(() => setShown((k) => (k === key ? '' : k)), LAST_RESULT_MS);
    return () => clearTimeout(t);
  }, [key]);
  if (!p) return null;
  const showLast = !!p.lastResult && shown === key;
  return (
    <div class={`hf-practice ${p.side}`} role="region" aria-label="Practice">
      <span class="hf-practice__tag t-display">PRACTICE</span>
      <span class="hf-practice__side t-broadcast">{p.side === 'offense' ? 'ON OFFENSE' : 'ON DEFENSE'}</span>
      {showLast ? (
        <span class="hf-practice__last t-broadcast" key={key} role="status">
          LAST: {p.lastResult}
        </span>
      ) : (
        <span class="hf-practice__plays t-broadcast">PLAY {p.plays + 1}</span>
      )}
      <button class="hf-practice__btn interactive" onClick={() => actions.practiceReset()}>
        <Key label="R" /> RESET BALL
      </button>
      <button class="hf-practice__btn interactive" onClick={() => actions.practiceSwapSides()}>
        <Key label="TAB" /> SWAP SIDES
      </button>
    </div>
  );
}
